import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-8 sm:py-12 px-4 bg-brand-olive-dark text-white" data-id="element-62">
      <div className="max-w-xl mx-auto text-center" data-id="element-63">
        <div className="mb-6" data-id="element-64">
          <h2 className="text-2xl sm:text-4xl font-serif font-bold mb-3" data-id="element-65">
            Letzte Chance
          </h2>
          <p className="text-sm sm:text-base text-gray-200 font-medium mb-4" data-id="element-66">
            Ihr Körper verdient das Beste — nicht eine eingeschränkte Version
            Ihres Lebens. Diabetes oder Glutenintoleranz bedeuten nicht, dass
            Sie für immer auf Genuss verzichten müssen. 500 Rezepte warten auf
            Sie.
          </p>
          <p className="text-lg font-bold text-brand-gold" data-id="element-67">
            METABOLIK PRO — 6 Bücher + 5 Luxus-Bonus
          </p>
          <p className="text-xl mt-2" data-id="element-68">
            <span className="line-through text-gray-400 text-base mr-2" data-id="element-69">
              97€
            </span>
            <span className="font-bold" data-id="element-70">🔥 19€</span>
          </p>
        </div>

        <div className="space-y-4" data-id="element-71">
          <CTAButton href="https://500-rezepte.impultienda.ar/checkout" variant="premium" className="w-full sm:w-auto min-w-0 sm:min-w-[300px]" data-id="element-72">
            🌿 JA, ICH WILL MEIN METABOLIK PRO
          </CTAButton>

          <div className="text-center mt-4 space-y-2" data-id="element-73">
            <p className="text-xs text-gray-300 font-medium" data-id="element-74">
              Sofortiger Zugang — Lieferung per E-Mail
            </p>
            <div className="flex justify-center items-center gap-2 text-xs font-medium text-white" data-id="element-75">
              <span className="text-brand-gold" data-id="element-76">⭐⭐⭐⭐⭐</span> 4.9/5
              <span className="text-white/30" data-id="element-77">|</span>
              <span data-id="element-78">🛡️ 30-Tage-Garantie</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}